.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 520px), 1fr));
  gap: 24px;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-subtle);
}

.head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.head h2 {
  font-size: 1.25rem;
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 16px;
  margin: 0;
}

.stats dt {
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.stats dd {
  margin: 4px 0 0;
  font-size: 1.75rem;
  font-weight: 650;
  font-family: var(--font-mono);
}

.alert {
  color: var(--accent-text);
}
